import {UserPlusIcon} from "@heroicons/react/20/solid";
import {AppAccessMobileApp} from "@ots-frontend/ots-data";
import {OtsActionButton} from "../components/OtsButton";
import {appAccessApps, appAccessCardClass} from "./app-access-ui";

export type AppAccessQuickStartProps = {
  onSelectApp: (app: AppAccessMobileApp) => void;
  disabled?: boolean;
};

/** Per-app shortcuts for creating a short-lived, one-person setup. */
export const AppAccessQuickStart = ({
  onSelectApp,
  disabled = false,
}: AppAccessQuickStartProps) => (
  <section className={appAccessCardClass} aria-labelledby="app-access-quick-start-heading">
    <div>
      <h2 id="app-access-quick-start-heading" className="text-lg font-semibold text-[var(--ots-secondary)]">
        Start a one-person setup
      </h2>
      <p className="mt-1 text-sm text-[var(--ots-text-muted)]">
        Pick the app they need, then send a short-lived secure link or QR code.
      </p>
    </div>

    <div className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {appAccessApps.map((app) => (
        <OtsActionButton
          key={app.id}
          variant="secondary"
          disabled={disabled}
          onClick={() => onSelectApp(app.id)}
          className="min-h-20 !justify-start !px-3 text-left">
          <img src={app.logo} alt="" className="size-11 shrink-0 rounded-xl"/>
          <span className="min-w-0">
            <span className="block font-semibold">{app.label}</span>
            <span className="mt-0.5 block text-xs font-normal text-[var(--ots-text-muted)]">
              <UserPlusIcon className="mr-1 inline size-3.5"/>Quick setup
            </span>
          </span>
        </OtsActionButton>
      ))}
    </div>
  </section>
);
